import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IBillingTransactions } from '@dch/billing-business-logic';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import { map, catchError, withLatestFrom, mergeMap } from 'rxjs/operators';
import { BILLING_TRANSACTIONS_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';
import {
  getBillingTransactionsFailure,
  getBillingTransactionsRequest,
  getBillingTransactionsSuccess,
} from '../actions/billing-transactions.actions';
import { ApplicationState } from '../reducers';
import { selectCustomer } from '../selectors/customer-account.selector';

@Injectable()
export class BillingTransactionsEffects {
  getBillingTransactions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getBillingTransactionsRequest),
      withLatestFrom(this.store.select(selectCustomer)),
      mergeMap(([{ billingAccountNumber }, customer]) =>
        EntityManager.getEntity<IBillingTransactions>(
          BILLING_TRANSACTIONS_ENTITY,
          {
            cdbId: customer.customerId,
            billingAccountNumber,
          }
        ).pipe(
          map((entity) =>
            entity.value
              ? getBillingTransactionsSuccess({
                  billingAccountNumber,
                  transactions: entity.value,
                })
              : getBillingTransactionsFailure({ billingAccountNumber })
          ),
          catchError(() =>
            of(getBillingTransactionsFailure({ billingAccountNumber }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>
  ) {}
}
